import { useState } from 'react'
import { Check, Copy } from 'lucide-react'
import styles from './CodeBlock.module.css'

/**
 * Блок кода с кнопкой «Копировать» в правом нижнем углу (правка №24): код в чате обычно берут,
 * чтобы вставить, а выделять его мышью по строкам неудобно. Кнопка — рядом с <pre>, не внутри:
 * иначе она попала бы в выделенный вручную текст.
 */
export function CodeBlock({ text, className }: { text: string; className?: string | undefined }) {
  const [copied, setCopied] = useState(false)
  const copy = () => {
    void navigator.clipboard
      ?.writeText(text)
      .then(() => {
        setCopied(true)
        window.setTimeout(() => setCopied(false), 1500)
      })
      .catch(() => undefined)
  }
  return (
    <div className={styles.wrap}>
      <pre className={className}>
        <code>{text}</code>
      </pre>
      <button type="button" className={styles.copy} data-tooltip={copied ? 'Скопировано' : 'Копировать'} aria-label={copied ? 'Код скопирован' : 'Копировать код'} onClick={copy}>
        {copied ? <Check size={14} /> : <Copy size={14} />}
      </button>
    </div>
  )
}
